import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedRuleInsuranceCategory.errors.";

const insuranceRegisterSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "insurance_register" },
);

export const insuranceCategorySchema = z.object({
  id: z.string().optional(),
  insuranceRegister: insuranceRegisterSchema,
  enable: z.boolean(),
});

export type TInsuranceCategoryForm = z.infer<typeof insuranceCategorySchema>;
